import { render } from "./CodeBlockTabSet.vue?vue&type=template&id=baae12a8"
import script from "./CodeBlockTabSet.vue?vue&type=script&lang=js"
export * from "./CodeBlockTabSet.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/code/CodeBlockTabSet.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "baae12a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('baae12a8', __exports__)) {
    api.reload('baae12a8', __exports__)
  }
  
  module.hot.accept("./CodeBlockTabSet.vue?vue&type=template&id=baae12a8", () => {
    api.rerender('baae12a8', render)
  })

}


export default __exports__